import React from "react";

import CategoriesPage from "../routes/categories-page";

const CategoriesTemplate = (props) => <CategoriesPage {...props} />;

export default CategoriesTemplate;
